import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { growthStages } from "@/mocks/arcs";

export default function Growth() {
  return (
    <section id="growth" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="成长轨迹"
            title="纲吉是怎么一步步改变的"
            desc="主角的成长不是一次觉醒，而是分阶段完成的。把这四个阶段连起来看，就能理解作品为什么把大量的日常篇幅放在最前面。"
          />
        </Reveal>

        <div className="mt-12 grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <ol className="relative space-y-6 border-l border-background-300 pl-6">
              {growthStages.map((stage, index) => (
                <Reveal key={stage.id} delay={index * 90}>
                  <li className="relative">
                    <span className="absolute -left-[31px] top-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-background-50 bg-primary-500">
                      <span className="h-1.5 w-1.5 rounded-full bg-background-50" />
                    </span>
                    <div className="rounded-lg border border-background-200 bg-background-100 p-5">
                      <span className="text-xs font-medium tracking-wide text-accent-700">{stage.phase}</span>
                      <h3 className="mt-1.5 font-heading text-base font-bold text-foreground-950 md:text-lg">{stage.title}</h3>
                      <p className="mt-2 text-sm leading-7 text-foreground-700">{stage.desc}</p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>

          <Reveal className="lg:col-span-5" delay={120}>
            <div className="sticky top-24 space-y-4">
              <div className="rounded-lg border border-background-200 bg-secondary-100 p-5">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-secondary-900">
                  <i className="ri-lightbulb-flash-line" />
                  一个容易被忽略的细节
                </h3>
                <p className="mt-3 text-sm leading-7 text-secondary-900/85">
                  作品很少描写纲吉「变强之后有多爽」，反而花了大量篇幅写他害怕、犹豫、想逃。这不是拖节奏，而是在为后续每一次选择积累重量——正因为知道他会怕，他仍然站出来的那一刻才有说服力。
                </p>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-100 p-5">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-group-line text-primary-600" />
                  成长的不只是主角
                </h3>
                <p className="mt-3 text-sm leading-7 text-foreground-700">
                  狱寺从血气方刚变得懂得配合，山本从把战斗当游戏变得理解分量，云雀从孤身一人到愿意在关键时刻出现在战场上。群像的共同成长，才是这部作品真正的厚度。
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}